module.exports = __webpack_public_path__ + "img/eliminar-test.38551276.png";